export default "__VITE_ASSET__DwNGbkVS__"